import React from "react";
import Search from "components/Search";
import Layout from "components/common/Layout";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";
import { usePageMeta } from "hooks/usePageMeta";
import { useRouterQuery } from "hooks/useRouterQuery";

const SearchPage = () => {
  const { routerQuery } = useRouterQuery();
  const metaMessage = `Search results for ${routerQuery.query || "Zur Institute."}`;

  usePageMeta("Search");

  return (
    <Layout
      initialMeta={{
        title: metaMessage,
        canonical: metaMessage,
        metaDesc: metaMessage,
        metaKeywords: metaMessage,
      }}
    >
      <Search />
    </Layout>
  );
};

export default SearchPage;

export const getServerSideProps = withEnhancedServerSideProps(async ctx => {
  return {
    props: {
      query: ctx.query,
    },
  };
});
